module.exports = __webpack_public_path__ + "static/media/WhatsApp.301b3c0a.png";